import { Card, Empty, Select } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useHistory } from 'react-router-dom'
import CardTitle from '../../core/components/CardTitle'
import Flex from '../../core/components/Flex'
import LayoutWithSider from '../../core/components/layout/layout-with-sider/LayoutWithSider'
import AppConfig from '../../core/service/AppConfig'
import ApiService from '../../core/service/api-service'
import ReportOutputTemplateBuilder from '../../app/report-output-template/ReportOutputTemplateBuilder'
import { Pages } from '../../AppRouter'

/** Hastane seçimi + builder. Şablonlar hastane bazlı olduğu için önce hastane seçilir. */
export default function ReportOutputTemplatePage() {
    const { t } = useTranslation()
    const history = useHistory()
    const { hospitalId } = useParams()

    const [hospitals, setHospitals] = useState([])
    const selected = hospitalId ? Number(hospitalId) : null

    useEffect(() => {
        document.title = `${t('Rapor Çıktı Şablonları')} | ${AppConfig.getRisTitle()}`
    }, [t])

    useEffect(() => {
        ApiService.Hospital.GetList().then((res) => {
            if (res.success) setHospitals(res.data || [])
        })
    }, [])

    const Title = () => (
        <Flex justifyContent="space-between" alignItems="center">
            <CardTitle title={t('Rapor Çıktı Şablonları')} />
            <Select
                size="small"
                showSearch
                optionFilterProp="label"
                style={{ minWidth: 260 }}
                placeholder={t('Hastane seçin')}
                value={selected || undefined}
                onChange={(id) => history.push(Pages.ReportOutputTemplate.Edit(id))}
                options={hospitals.map((h) => ({ value: h.id, label: h.name }))}
            />
        </Flex>
    )

    return (
        // Filtre paneli yok ama sarmalayıcı yine LayoutWithSider: içerik kutusunun sabit header
        // ve footer'dan kaçınan margin'leri ORADA tanımlı (bkz. ViewerSettingsPage). Çıplak
        // ResponsiveLayout yalnızca Row/Col veriyor, sayfa header'ın altına giriyordu.
        <LayoutWithSider fullWidth={true}>
            <Card title={<Title />}>
                {selected ? (
                    <ReportOutputTemplateBuilder hospitalId={selected} />
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('Devam etmek için hastane seçin')} />
                )}
            </Card>
        </LayoutWithSider>
    )
}
